module.exports = __webpack_public_path__ + "static/media/my-account-bg.3ef68129.png";